var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M23.9438 37.926L20.7036 36.959L25.4635 22.926L28.7036 23.893L23.9438 37.926ZM3.70361 49.0742H46.2962V13.889H33.3332V0.926025H3.70361V49.0742ZM19.7031 36.7767L17.351 38.926L10.7036 31.426L17.3515 23.926L19.7036 26.0748L14.9603 31.426L19.7031 36.7767ZM32.0557 38.926L29.7036 36.7768L34.4462 31.4264L29.7043 26.076L32.0563 23.926L38.7036 31.4258L32.0557 38.926Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoding);
export default __webpack_public_path__ + "static/media/coding.6d0cff32f9baa8dd87554aae6e37de7f.svg";
export { ForwardRef as ReactComponent };